import React, { useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '.././Authentication/auth';

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const Userstable = ({ searchTerm }) => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const usersPerPage = 13;

  // Fetch Users Data
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const user = await getCurrentUser();
        const userEmail = user?.email;

        if (userEmail) {
          const response = await fetch(
            `${AQ_BASE_URL}/aq/api/getUsers?email=${encodeURIComponent(userEmail)}`
          );

          if (!response.ok) {
            throw new Error('Failed to fetch users.');
          }

          const data = await response.json();
          if (Array.isArray(data)) {
            const formattedData = data.map((user) => ({
              id: user.id,
              firstname: user.first_name,
              lastname: user.last_name,
              username: user.username,
              email: user.email,
              mobile_number: user.mobile_number,
              role: user.roles.join(', '),
              created_at: user.created_at,
            }));
            setUsers(formattedData);
          } else {
            console.error('Invalid user data format:', data);
          }
        } else {
          console.error('No email found in decoded token.');
        }
      } catch (error) {
        console.error('Error fetching users:', error.message);
      }
    };

    fetchUsers();
  }, []);

  // Filtered Users based on SearchTerm
  const filteredUsers = users.filter(
    (user) =>
      `${user.firstname} ${user.lastname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const startIndex = (currentPage - 1) * usersPerPage;
  const endIndex = startIndex + usersPerPage;
  const currentUsers = filteredUsers.slice(startIndex, endIndex);

  const handleViewUser = (user) => {
    // Navigate to the edit page with user ID as parameter
    navigate(`/dashboard/mdm/users/edit/${user.id}`);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const generatePageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`px-4 rounded-full font-semibold mx-1 ${
            currentPage === i ? 'bg-black text-white' : 'bg-gray-300 text-black hover:bg-gray-400'
          }`}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  const renderUserTable = () => (
    <div className="overflow-x-auto">
      <h1 className="p-2 text-black rounded-t-lg font-bold text-lg">Users List</h1>
      <table className="min-w-full  shadow-lg rounded-md">
        <thead className="bg-gray-300 text-gray-600">
          <tr>
            <th className="py-2 px-3 text-left font-medium">Name</th>
            <th className="py-1 px-2 text-left font-medium">Username</th>
            <th className="py-1 px-2 text-left font-medium">Email</th>
            <th className="py-1 px-2 text-left font-medium">Role</th>
            <th className="py-1 px-2 text-left font-medium">Mobile No.</th>
            <th className="py-1 px-2 text-left font-medium">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((user, id) => (
              <tr key={id} className="border-b hover:bg-gray-100">
                <td className="py-3 px-3 text-sm">
                  <span>{`${user.firstname} ${user.lastname}`}</span>
                </td>
                <td className="py-2 px-2 text-sm">{user.username}</td>
                <td className="py-2 px-2 text-sm">{user.email}</td>
                <td className="py-2 px-2 text-sm">{user.role}</td>
                <td className="py-2 px-2 text-sm">{user.mobile_number}</td>
                <td className="py-1 px-2 text-sm">
                  <FaEye
                    size={20}
                    className="inline cursor-pointer text-gray-900"
                    onClick={() => handleViewUser(user)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="py-3 px-4 text-center text-sm">
                No user data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="mt-4 space-y-4 h-screen">
      {renderUserTable()}

      {/* Pagination Buttons */}
      <div className="flex justify-center mt-4 space-x-2">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 bg-black rounded-lg text-white font-semibold hover:scale-105 disabled:opacity-50"
        >
          Previous
        </button>
        {generatePageNumbers()}
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="px-4 py-2 bg-black rounded-lg text-white font-semibold hover:scale-105 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Userstable;

// import React, { useEffect, useState } from "react";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import { IoWarning } from "react-icons/io5";
// import EditUser from "./EditUser"; // Import the EditUser component
// import { getCurrentUser } from ".././Authentication/auth"; // adjust the path if it's somewhere else

// const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;
// const Userstable = ({ searchTerm }) => {
//   const [users, setUsers] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [showEditUser, setShowEditUser] = useState(false); // State to show edit user modal

//   const usersPerPage = 13;

//   // Fetch Users Data
//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const user = await getCurrentUser();
//         const userEmail = user?.email;

//         if (userEmail) {
//           const response = await fetch(
//             `${AQ_BASE_URL}/aq/api/getUsers?email=${encodeURIComponent(
//               userEmail
//             )}`
//           );

//           if (!response.ok) {
//             throw new Error("Failed to fetch users.");
//           }

//           const data = await response.json();
//           if (Array.isArray(data)) {
//             const formattedData = data.map((user) => ({
//               id: user.id,
//               firstname: user.first_name,
//               lastname: user.last_name,
//               username: user.username,
//               email: user.email,
//               mobile_number: user.mobile_number,
//               role: user.roles.join(", "),
//               created_at: user.created_at,
//             }));
//             setUsers(formattedData);
//           } else {
//             console.error("Invalid user data format:", data);
//           }
//         } else {
//           console.error("No email found in decoded token.");
//         }
//       } catch (error) {
//         console.error("Error fetching users:", error.message);
//       }
//     };

//     fetchUsers();
//   }, []);

//   const closeModal = () => {
//     setShowEditUser(false);
//   };
//   // Filtered Users based on SearchTerm
//   const filteredUsers = users.filter(
//     (user) =>
//       `${user.firstname} ${user.lastname}`
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase()) ||
//       user.email.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
//   const startIndex = (currentPage - 1) * usersPerPage;
//   const endIndex = startIndex + usersPerPage;
//   const currentUsers = filteredUsers.slice(startIndex, endIndex);

//   const handleDelete = (user) => {
//     setSelectedUser(user);
//     setShowDeleteModal(true);
//   };

//   // Confirm Delete User Function with API Call
//   const confirmDelete = async () => {
//     try {
//       const user = await getCurrentUser();
//       const userEmail = user?.email;

//       const response = await fetch(
//         `${AQ_BASE_URL}/aq/api/deleteUser?user_id=${
//           selectedUser.id
//         }&email=${encodeURIComponent(userEmail)}`,
//         {
//           method: "DELETE",
//           headers: {
//             accept: "application/json",
//           },
//         }
//       );

//       const result = await response.json();
//       console.log("API Response:", result);

//       if (!response.ok) {
//         console.error(
//           "Failed to delete the user. Response status:",
//           response.status
//         );
//         throw new Error(result.message || "Failed to delete the user.");
//       }

//       if (result.success) {
//         // Remove the user from state after successful deletion
//         setUsers((prevUsers) =>
//           prevUsers.filter((user) => user.id !== selectedUser.id)
//         );
//         console.log("User deleted successfully:", result.message);
//       } else {
//         console.error("API returned an error:", result.message);
//       }
//     } catch (error) {
//       console.error("Error deleting user:", error.message);
//     } finally {
//       setShowDeleteModal(false);
//       setSelectedUser(null);
//     }
//   };

//   const handlePageClick = (page) => {
//     setCurrentPage(page);
//   };

//   const generatePageNumbers = () => {
//     const pages = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pages.push(
//         <button
//           key={i}
//           onClick={() => handlePageClick(i)}
//           className={`px-4 rounded-full font-semibold mx-1 ${
//             currentPage === i
//               ? "bg-blue-500 text-white"
//               : "bg-gray-300 text-black hover:bg-gray-400"
//           }`}
//         >
//           {i}
//         </button>
//       );
//     }
//     return pages;
//   };

//   const renderUserTable = () => (
//     <div className="overflow-x-auto">
//       <h1 className="p-2 bg-white text-black rounded-t-lg font-bold text-lg">
//         Users List
//       </h1>
//       <table className="min-w-full bg-white shadow-lg rounded-md">
//         <thead className="bg-gray-300 text-gray-600">
//           <tr>
//             <th className="py-2 px-3 text-left font-medium">Name</th>
//             <th className="py-1 px-2 text-left font-medium">Username</th>
//             <th className="py-1 px-2 text-left font-medium">Email</th>
//             <th className="py-1 px-2 text-left font-medium">Role</th>
//             <th className="py-1 px-2 text-left font-medium">Mobile No.</th>
//             <th className="py-1 px-2 text-left font-medium">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentUsers.length > 0 ? (
//             currentUsers.map((user, id) => (
//               <tr key={id} className="border-b hover:bg-gray-100">
//                 <td className="py-3 px-3 text-sm">
//                   <span>{`${user.firstname} ${user.lastname}`}</span>
//                 </td>
//                 <td className="py-2 px-2 text-sm">{user.username}</td>
//                 <td className="py-2 px-2 text-sm">{user.email}</td>
//                 <td className="py-2 px-2 text-sm">{user.role}</td>
//                 <td className="py-2 px-2 text-sm">{user.mobile_number}</td>
//                 <td className="py-1 px-2 text-sm">
//                   <FaEdit
//                     size={20}
//                     className="inline cursor-pointer text-blue-500 mr-4"
//                     onClick={() => {
//                       setSelectedUser(user);
//                       setShowEditUser(true); // Show the Edit User modal
//                     }}
//                   />
//                   <FaTrash
//                     size={20}
//                     className="inline cursor-pointer text-red-500"
//                     onClick={() => handleDelete(user)} // Call handleDelete
//                   />
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="6" className="py-3 px-4 text-center text-sm">
//                 No user data found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );

//   return (
//     <div className="mt-4 space-y-4">
//       {renderUserTable()}

//       {/* Pagination Buttons */}
//       <div className="flex justify-center mt-4 space-x-2">
//         <button
//           onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//           disabled={currentPage === 1}
//           className="px-4 py-2 bg-black rounded-lg text-white font-semibold hover:scale-105 disabled:opacity-50"
//         >
//           Previous
//         </button>
//         {generatePageNumbers()}
//         <button
//           onClick={() =>
//             setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//           }
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 bg-black rounded-lg text-white font-semibold hover:scale-105 disabled:opacity-50"
//         >
//           Next
//         </button>
//       </div>

//       {/* Delete Modal */}
//       {showDeleteModal && (
//         <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
//           <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm text-center">
//             <div className="flex flex-1 gap-1 items-center justify-center">
//               <IoWarning size={22} className="mb-4 text-red-600" />
//               <h2 className="text-lg font-semibold mb-4">Delete User</h2>
//             </div>
//             <p className="text-sm mb-10">
//               Are you sure you want to delete this user? This action is
//               permanent and cannot be undone.
//             </p>
//             <div className="flex justify-end gap-2">
//               <button
//                 onClick={() => setShowDeleteModal(false)}
//                 className="px-6 py-2 bg-gray-300 rounded-lg font-semibold text-black hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDelete} // Confirm delete function
//                 className="px-6 py-2 bg-red-500 rounded-lg font-semibold text-white hover:bg-red-700"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit User Modal */}
//       {showEditUser && (
//         <EditUser
//           selectedUser={selectedUser}
//           setShowEditUser={setShowEditUser}
//           closeModal={closeModal} // Pass setShowEditUser to allow closing the modal
//         />
//       )}
//     </div>
//   );
// };

// export default Userstable;
